import { combineReducers } from "redux";
import { connectRouter } from "connected-react-router";
import login from "./LoginReducer";
import accounts from "./AccountReducer";
import journals from "./JournalReducer";
import notifications from "./NotificationReducer";
import productBatch from "./ProductBatcheReducer";
import products from "./ProductReducer";
import discounts from "./DiscountReducer";
import salesInvoices from "./SalesInvoiceReducer";
import challanInvoices from "./ChallanInvoiceReducer"
import reports from "./ReportReducer";
import user from "./UserReducer";
import role from "./RoleReducer";
import log from "./LogReducer";
import attachments from "./AttachmentReducer";
import salesHistory from "./ProductSalesHistoryReducer";
import employee from "./EmployeeReducer";
import employeeRole from "./EmployeeRoleReducer";
import salesData from "./SalesDataReducer";
import distributorStock from "./DistributorStockReducer";
import salesReport from "./SalesReportReducer";
import employeeArea from "./EmployeeAreaReducer";
import stock from "./StockReducer";
import { loadingBarReducer } from "react-redux-loading-bar";
import orgUnit from "./OrgUnitReducer";
import bank from "./BankChequeReducer";
import configurations from "./ConfigurationReducer";
import purchaseInvoices from "./PurchaseInvoiceReducer";


const reducers = {
    login,
    accounts,
    journals,
    notifications,
    products,
    discounts,
    productBatch,
    salesInvoices,
    purchaseInvoices,
    user,
    role,
    reports,
    log,
    attachments,
    salesHistory,
    employee,
    employeeRole,
    salesData,
    distributorStock,
    salesReport,
    employeeArea,
    challanInvoices,
    stock,
    orgUnit,
    bank,
    configurations
};

const rootReducer = (history)=> combineReducers({
    ...reducers,
    router: connectRouter(history),
    loadingBar: loadingBarReducer
});

export default rootReducer;


// WEBPACK FOOTER //
// ./src/reducers/index.js